import { isSuccess } from '@devexperts/remote-data-ts'
import { createSelector } from '@reduxjs/toolkit'
import { extraSlice } from '@/store/extraSlice'
import { cartSlice } from '..'

export const selectTotalPrice = (isUsingCartInfoData?: boolean) =>
  createSelector(
    [
      cartSlice.selectors.cartDetailPrices,
      cartSlice.selectors.quoteWithDiscount,
      cartSlice.selectors.quote,
    ],
    (cartDetail, quoteWithDiscount, quote): number => {
      if (isUsingCartInfoData) {
        return cartDetail?.totalPrice ?? 0
      }
      if (isSuccess(quoteWithDiscount)) {
        return quoteWithDiscount.value.totalPrice
      }
      if (isSuccess(quote)) {
        return quote.value.totalPrice
      }
      return 0
    }
  )

export const selectWeatherInsurancePrice = (isUsingCartInfoData?: boolean) =>
  createSelector(
    [
      cartSlice.selectors.cartDetail,
      extraSlice.selectors.weatherInsurancePricePreview,
    ],
    (cartDetail, weatherInsurancePricePreview) => {
      if (isUsingCartInfoData && isSuccess(cartDetail)) {
        return cartDetail.value.cart.weatherPolicy?.price ?? 0
      }
      if (isSuccess(weatherInsurancePricePreview)) {
        return weatherInsurancePricePreview.value
      }
      return 0
    }
  )

export const selectTotal = (isUsingCartInfoData?: boolean) =>
  createSelector(
    [
      cartSlice.selectors.isWeatherInsuranceAddedToCart,
      selectTotalPrice(isUsingCartInfoData),
      selectWeatherInsurancePrice(isUsingCartInfoData),
    ],
    (isWeatherInsuranceAddedToCart, totalPrice, weatherInsurancePrice) => {
      if (isWeatherInsuranceAddedToCart) {
        return totalPrice + weatherInsurancePrice
      }
      return totalPrice
    }
  )
